import { Button, Col, Row } from "react-bootstrap";
import * as icons from "react-bootstrap-icons";

/**
 * The rows-per-page select and previous/next controls under a results table. Takes the values
 * usePagedList returns; renders nothing while everything fits on one page. A list with one page
 * size (the player's Auctions list, #236) gets no select.
 */
export const ResultsPager = ({
  page,
  totalPages,
  perPage,
  pageSizes,
  onPerPageChange,
  onPrevious,
  onNext,
}) => {
  if (totalPages <= 1) return null;

  return (
    <Row>
      <Col md={12} className="text-right">
        <div className="pagination-controls">
          {pageSizes.length > 1 && (
            <>
              <label htmlFor="itemsPerPage">Rows per page: </label>
              <select
                id="itemsPerPage"
                value={perPage}
                onChange={(e) => onPerPageChange(Number(e.target.value))}
              >
                {pageSizes.map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </>
          )}

          <Button onClick={onPrevious} disabled={page <= 1}>
            <icons.ArrowLeft />
          </Button>
          <span>
            {" "}
            {page} of {totalPages}{" "}
          </span>
          <Button onClick={onNext} disabled={page >= totalPages}>
            <icons.ArrowRight />
          </Button>
        </div>
      </Col>
    </Row>
  );
};
